import React from "react"
import DfbQuote from "../ui-kit/dfb_quote"
import Section from "./section"

const MQuote = (props) => {
  let sectionClasses = ""
  let dfbQuoteClasses = ""
  let text = props.data.text || props.data.plaintext

  if (props.data.layout === "big") {
    dfbQuoteClasses = "dfb-Quote--big"
  }

  if (props.data.layout === "big-left") {
    sectionClasses = "m-Quote--big-left"
    dfbQuoteClasses = "dfb-Quote--big"
  }

  if (props.data.layout === "left-aligned") {
    dfbQuoteClasses = "dfb-Quote--left"
  }

  return (
    <Section
      baseClass="m-Quote"
      className={sectionClasses}
      defaultPadding="large"
      data={props.data}
    >
      <div className="m-Quote-wrapper">
        <DfbQuote
          text={text}
          quote_author={props.data.quote_author}
          quote_author_position={props.data.quote_author_position}
          add_class={dfbQuoteClasses}
        />
      </div>
    </Section>
  )
}

export default MQuote